import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { UpdateConfigurationComponent } from './update-configuration.component';
import { MatRadioModule } from '@angular/material/radio';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';

@NgModule({
  declarations: [
    UpdateConfigurationComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    SidenavHeaderModule,
    IconsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    SearchFilterModule,
    PaginatorModule,
  ],
  exports: [
    UpdateConfigurationComponent
  ]
})
export class UpdateConfigurationModule { }
